import { AutocompleteInput } from "@/components/admin";
import { Card } from "@/components/ui/card";
import {
  DataTable,
  DateField,
  List,
  ListActions,
  NeutralBadge,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  TextField,
} from "../common";

const statusChoices = [
  { id: "pending", name: "Pending" },
  { id: "approved", name: "Approved" },
  { id: "rejected", name: "Rejected" },
  { id: "cancelled", name: "Cancelled" },
];

const filters = [
  <ReferenceInput key="employee_id" source="employee_id" reference="employees">
    <AutocompleteInput label="Employee" optionText="name" />
  </ReferenceInput>,
  <SelectInput key="status" source="status" choices={statusChoices} />,
];

export const LeaveRequestList = () => (
  <List
    title="Leave Requests"
    filters={filters}
    actions={<ListActions label="Request Leave" />}
    sort={{ field: "created_at", order: "DESC" }}
  >
    <Card className="border border-border rounded-xl bg-card shadow-sm overflow-hidden">
      <DataTable rowClick="show">
        <DataTable.Col label="Employee">
          <ReferenceField source="employee_id" reference="employees" link={false}>
            <TextField source="name" className="font-semibold" />
          </ReferenceField>
        </DataTable.Col>
        <DataTable.Col label="Type">
          <ReferenceField
            source="leave_type_id"
            reference="hr_leave_types"
            link={false}
          >
            <TextField source="name" />
          </ReferenceField>
        </DataTable.Col>
        <DataTable.Col source="from_date" label="From">
          <DateField source="from_date" />
        </DataTable.Col>
        <DataTable.Col source="to_date" label="To">
          <DateField source="to_date" />
        </DataTable.Col>
        <DataTable.Col source="days" label="Days" />
        <DataTable.Col label="Status">
          <NeutralBadge />
        </DataTable.Col>
      </DataTable>
    </Card>
  </List>
);

